import { render, staticRenderFns } from "./SisClassroomFacilitators.vue?vue&type=template&id=8c2ed2a0&"
import script from "./SisClassroomFacilitators.vue?vue&type=script&lang=ts&"
export * from "./SisClassroomFacilitators.vue?vue&type=script&lang=ts&"
import style0 from "./SisClassroomFacilitators.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports